import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import "moment/locale/pt-br";
import { api_url_destaques_image } from "../providers/api";

export default class TBLDestaques extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.columns = [
      {
        Header: "Banner",
        accessor: "foto_destaque",
        Cell: (props) => (
          <img
            src={api_url_destaques_image + props.value}
            height={80}
            style={{ borderRadius: 10 }}
          />
        ),
        className: "center",
      },
      {
        Header: "Descrição",
        accessor: "descricao",
        className: "center",
      },
      {
        Header: "Corredor Vinculado",
        accessor: "corredor",
        Cell: (props) => <span>{props.value?.nome || "-"}</span>,
        className: "center",
      },
      {
        Header: "Qtd. Produtos",
        accessor: "produtos",
        Cell: (props) => <span>{props.value?.length || "-"}</span>,
        className: "center",
      },
    ];
    this.acoes = [
      {
        Header: "Ações",
        Cell: (row) => (
          <div>
            <Button
              size="sm"
              style={{ marginRight: 4 }}
              onClick={() => this.gerenciarAcoes("editar", row.row._original)}
            >
              <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
            </Button>
            <Button
              size="sm"
              variant="danger"
              onClick={() => this.gerenciarAcoes("deletar", row.row._original)}
            >
              <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
            </Button>
          </div>
        ),
        className: "center",
      },
    ];
  }

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "editar") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    return (
      <ReactTable
        data={this.props.data}
        className="-striped -highlight"
        columns={this.props.showAcoes ? [...this.columns, ...this.acoes] : this.columns}
        resizable
        style={{ maxHeight: 572 }}
        showPagination={this.props.showPagination}
        defaultPageSize={this.props.numRows}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando..."
        noDataText="Nenhum dado encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLDestaques.propTypes = {
  data: PropTypes.array,
  showPagination: PropTypes.bool,
  numRows: PropTypes.number,
  dataCallback: PropTypes.func,
  showAcoes: PropTypes.bool,
};
